import AiOmnibar from "@medflyt/webapp-react/src/modules/ai-omnibar/components/AiOmnibar";
import AiSettingsModal from "@medflyt/webapp-react/src/modules/ai-omnibar/components/AiSettingsModal";
import ImportantCallsPopover from "@medflyt/webapp-react/src/modules/call-center/components/ImportantCallsPopover/index";
import DocumentViewer from "@medflyt/webapp-react/src/modules/compliance/components/DocumentViewer";
import EntityNotes from "@medflyt/webapp-react/src/modules/note/components/EntityNotes";
import UncontrolledEntityNoteFormControls from "@medflyt/webapp-react/src/modules/note/components/UncontrolledEntityNoteFormControls";
import UncontrolledEntityNotesFormControls from "@medflyt/webapp-react/src/modules/note/components/UncontrolledEntityNotesFormControls";
import PatientClinicalSeverityLevelTag from "@medflyt/webapp-react/src/modules/patient/components/PatientClinicalSeverityLevelTag";
import PatientSelect from "@medflyt/webapp-react/src/modules/patient/components/PatientSelect";
import HoursRestrictionErrorModal from "@medflyt/webapp-react/src/modules/OfficeHoursRestrictions/HoursRestrictionErrorModal";
import PatientDocumentPOCItem from "@medflyt/webapp-react/src/modules/PatientDocumentPOCItem/PatientDocumentPOCItem";
import PatientDocumentSectionedIcdCodes from "@medflyt/webapp-react/src/modules/PatientDocumentSectionedIcdCodes/PatientDocumentSectionedIcdCodes";
import PatientPrimaryPhysician from "@medflyt/webapp-react/src/modules/patientPhysician/PatientPrimaryPhysician";
import PatientOutsourcingInfoBar from "@medflyt/webapp-react/src/modules/patient/components/PatientOutsourcingInfoBar";
import MissingTaskBanner from "@medflyt/webapp-react/src/modules/patient/components/MissingTaskBanner";
import CaregiverProfileModal from "@medflyt/webapp-react/src/modules/caregiverProfileModal/CaregiverProfileModal";
import PatientProfileModal from "@medflyt/webapp-react/src/modules/patientProfileModal/PatientProfileModal";
import ProfileWindowSettingsModal from "@medflyt/webapp-react/src/modules/profileWindowSettings/ProfileWindowSettingsModal";
import BetaFeaturesModal from "@medflyt/webapp-react/src/modules/betaFeatures/BetaFeaturesModal";
import PatientTaskMetricsRoute from "@medflyt/webapp-react/src/modules/patientTasksMetrics/PatientTaskMetricsModal";
import TasksNewPage from "@medflyt/webapp-react/src/modules/care-and-task-management/tasks-new/TasksNewPage";
import TasksV2Page from "@medflyt/webapp-react/src/modules/care-and-task-management/tasks-v2/TasksV2Page";
import RnSchedulingMapPage from "@medflyt/webapp-react/src/modules/care-and-task-management/rn-scheduling-map/RnSchedulingMapPage";
import PatientTaskCustomizeDayTimeParams from "@medflyt/webapp-react/src/modules/PatientTaskCustomizeDayTimeParams/PatientTaskCustomizeDayTimeParams";
import PatientTaskDocumentChangeRequestsTable from "@medflyt/webapp-react/src/modules/patient/components/PatientTaskDocumentChangeRequestsTable";
import PatientTaskDocumentRejectionsTable from "@medflyt/webapp-react/src/modules/patient/components/PatientTaskDocumentRejectionsTable";
import PatientTaskChat from "@medflyt/webapp-react/src/shared/components/PatientTaskChat";
import PatientMedicalDiagnosisCodeSection from "@medflyt/webapp-react/src/modules/patient/components/PatientMedicalDiagnosisCodeSection";
import PatientCdscImportSection from "@medflyt/webapp-react/src/modules/servicePlan/components/PatientCdscImportSection";
import AiWeeklyTemplateBuilderSection from "@medflyt/webapp-react/src/modules/ai-weekly-template-builder/components/AiWeeklyTemplateBuilderSection";
import PatientMedicationSection from "@medflyt/webapp-react/src/modules/patient/components/PatientMedicationSection";
import CaregiverExtendedContactDetails from "@medflyt/webapp-react/src/modules/caregiver/components/CaregiverExtendedContactDetails";
import CaregiverProfileValidatedDutiesSection from "@medflyt/webapp-react/src/modules/caregiverProfileModal/sections/profile/validatedDuties/CaregiverProfileValidatedDutiesSection";
import { RnPerformanceBlocksTable } from "@medflyt/webapp-react/src/modules/caregiver/components/RnPerformanceBlocks";
import CertificationBroadcastSettingsTable from "@medflyt/webapp-react/src/modules/certification-broadcast-settings/CertificationBroadcastSettingsTable";
import NursingQuestionSettingsSection from "@medflyt/webapp-react/src/modules/nursingQuestionSettings/components/NursingQuestionSettingsSection";
import PlanOfCareTypeSettingsSection from "@medflyt/webapp-react/src/modules/planOfCareType/components/PlanOfCareTypeSettingsSection";
import UndoReassignMissedDutyButton from "@medflyt/webapp-react/src/modules/planOfCare/UndoReassignMissedDutyButton";
import OfficeBranchSettings from "../../../../webapp-react/src/modules/office-branch/OfficeBranchSettings";
import PdfEditorSection from "@medflyt/webapp-react/src/modules/pdf-form-template/components/PdfEditorSection";
import ScheduledReportsSection from "@medflyt/webapp-react/src/modules/scheduledReports/components/ScheduledReportsSection";
import { withAppOnly, withBasicApp, withRouter } from "@medflyt/webapp-react/src/utils";
import ServiceCodeIssuesOverrideSection from "@medflyt/webapp-react/src/modules/contract/components/ServiceCodeIssuesOverrideSection";
import ComplianceDashboardTable from "../../../../webapp-react/src/modules/compliance/ComplianceDashboardTable";
import angular from "angular";
import { angularize } from "react-in-angularjs";

export function angularizeReactComponents() {
  angularize(withAppOnly(AiOmnibar), "reactAiOmnibar", angular.module("dashboard"), {
    isActive: "<",
    onExit: "&",
  });

  angularize(withAppOnly(AiSettingsModal), "reactAiSettingsModal", angular.module("dashboard"), {
    onClose: "&",
  });

  angularize(
    withAppOnly(ScheduledReportsSection),
    "reactScheduledReportsSection",
    angular.module("dashboard"),
    {
      reportType: "<",
      reportId: "<",
    }
  );

  angularize(withBasicApp(DocumentViewer), "canvasViewer", angular.module("dashboard"), {
    src: "<",
  });

  angularize(
    withAppOnly(ServiceCodeIssuesOverrideSection),
    "reactServiceCodeIssuesOverride",
    angular.module("dashboard"),
    {
      contractTypeId: "<",
      officeId: "<",
    }
  );

  angularize(
    withBasicApp(PatientTaskCustomizeDayTimeParams),
    "reactPatientTaskCustomizeDayTimeParams",
    angular.module("dashboard"),
    {
      onChange: "&",
      dateRange: "<",
      disableDates: "<",
      dayTimeScheduleOverrideParams: "<",
    }
  );

  angularize(
    withAppOnly(PatientClinicalSeverityLevelTag),
    "patientClinicalSeverityLevelBanner",
    angular.module("dashboard"),
    { clinicalSeverityLevel: "<" }
  );

  angularize(
    withAppOnly(PatientOutsourcingInfoBar),
    "patientOutsourcingInfoBar",
    angular.module("dashboard"),
    {}
  );

  angularize(withAppOnly(MissingTaskBanner), "missingTaskBanner", angular.module("dashboard"), {
    patient: "<",
  });

  angularize(withAppOnly(EntityNotes), "reactEntityNotes", angular.module("dashboard"), {
    entity: "<",
    onClose: "&",
  });

  angularize(
    withAppOnly(UncontrolledEntityNoteFormControls),
    "reactEntityNoteFormControls",
    angular.module("dashboard"),
    {
      isAnswerInvalid: "<",
      isMessageInvalid: "<",
      onChange: "<",
      noteType: "<",
    }
  );

  angularize(
    withAppOnly(UncontrolledEntityNotesFormControls),
    "reactEntityNotesFormControls",
    angular.module("dashboard"),
    {
      isAnswerInvalid: "<",
      isMessageInvalid: "<",
      onChange: "<",
      noteTypes: "=",
      onSuccess: "&",
    }
  );

  angularize(withAppOnly(PatientSelect), "reactPatientSelect", angular.module("dashboard"), {
    onChange: "<",
    value: "<",
  });

  angularize(
    withAppOnly(withRouter(PatientProfileModal)),
    "reactPatientProfileModal",
    angular.module("dashboard"),
    {
      patientId: "<",
      showBillingFeature: "<",
      onClose: "&",
      onReady: "&",
    }
  );

  angularize(
    withAppOnly(withRouter(CaregiverProfileModal)),
    "reactCaregiverProfileModal",
    angular.module("dashboard"),
    {
      caregiverId: "<",
      showBillingFeature: "<",
      onClose: "&",
      onReady: "&",
    }
  );

  // Rendered by the legacy patient/caregiver modals so their new settings button
  // opens the same React modal the beta window uses. The element is only in the
  // DOM while the modal is open, so it needs no `isOpen` binding.
  angularize(
    withAppOnly(ProfileWindowSettingsModal),
    "reactProfileWindowSettingsModal",
    angular.module("dashboard"),
    {
      onClose: "&",
    }
  );

  // Opened from the settings flyout in the sidebar, which is AngularJS. Like the
  // profile window settings modal, the element is only in the DOM while the
  // modal is open, so it needs no `isOpen` binding.
  angularize(
    withAppOnly(BetaFeaturesModal),
    "reactBetaFeaturesModal",
    angular.module("dashboard"),
    {
      onClose: "&",
    }
  );

  // The compliance dashboard's grid. The AngularJS component beside it stays for
  // the caregiver-memory-improvements flag being off; this is what the flag
  // switches on. No bindings: it owns its own filters, paging and fetching, the
  // same way the caregivers list does.
  angularize(
    withAppOnly(ComplianceDashboardTable),
    "reactComplianceDashboardTable",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(withRouter(ImportantCallsPopover)),
    "reactImportantCalls",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(PatientDocumentPOCItem),
    "reactPatientDocumentPocItem",
    angular.module("dashboard"),
    {
      item: "<",
      currentAnswer: "<",
      onChangeAnswer: "<",
      readonly: "<",
    }
  );

  angularize(
    withAppOnly(withRouter(HoursRestrictionErrorModal)),
    "reactHoursRestrictionErrorModal",
    angular.module("dashboard"),
    {
      conflicts: "<",
      onClose: "&",
    }
  );

  angularize(
    withAppOnly(withRouter(PatientPrimaryPhysician)),
    "reactPatientPrimaryPhysician",
    angular.module("dashboard"),
    {
      patientId: "<",
      isEdit: "<",
    }
  );

  angularize(
    withAppOnly(withRouter(PatientTaskMetricsRoute)),
    "reactPatientTaskMetrics",
    angular.module("dashboard"),
    {
      patientTaskInstanceId: "<",
      onClose: "&",
    }
  );

  angularize(
    withAppOnly(withRouter(PatientTaskChat)),
    "reactPatientTaskChat",
    angular.module("dashboard"),
    {
      patientId: "<",
    }
  );

  angularize(
    withAppOnly(withRouter(PatientTaskDocumentChangeRequestsTable)),
    "reactPatientTaskDocumentChangeRequestsTable",
    angular.module("dashboard"),
    {
      patientId: "<",
      onResolve: "&",
    }
  );

  angularize(
    withAppOnly(withRouter(PatientTaskDocumentRejectionsTable)),
    "reactPatientTaskDocumentRejectionsTable",
    angular.module("dashboard"),
    {
      patientId: "<",
      onUpdate: "&",
    }
  );

  angularize(
    withAppOnly(PatientMedicationSection),
    "reactPatientMedicationSection",
    angular.module("dashboard"),
    {
      patientId: "<",
    }
  );

  angularize(
    withAppOnly(PatientMedicalDiagnosisCodeSection),
    "reactPatientMedicalDiagnosisCodeSection",
    angular.module("dashboard"),
    {
      patientId: "<",
    }
  );

  angularize(
    withAppOnly(PatientCdscImportSection),
    "reactPatientCdscImportSection",
    angular.module("dashboard"),
    {
      patientId: "<",
    }
  );

  angularize(
    withAppOnly(AiWeeklyTemplateBuilderSection),
    "reactAiWeeklyTemplateBuilderSection",
    angular.module("dashboard"),
    {
      patientId: "<",
    }
  );

  angularize(
    withAppOnly(PatientDocumentSectionedIcdCodes),
    "reactPatientDocumentSectionedIcdCodes",
    angular.module("dashboard"),
    {
      documentId: "<",
      htmlTemplateId: "<",
      readonly: "<",
    }
  );

  angularize(
    withAppOnly(RnPerformanceBlocksTable),
    "reactRnPerformanceBlocksTable",
    angular.module("dashboard"),
    {
      caregiverId: "<",
    }
  );

  angularize(
    withAppOnly(CaregiverExtendedContactDetails),
    "reactCaregiverExtendedContactDetails",
    angular.module("dashboard"),
    {
      caregiverId: "<",
    }
  );

  angularize(
    withAppOnly(CaregiverProfileValidatedDutiesSection),
    "reactCaregiverValidatedDuties",
    angular.module("dashboard"),
    {
      caregiverId: "<",
      officeIds: "<",
    }
  );

  angularize(
    withAppOnly(CertificationBroadcastSettingsTable),
    "reactCertificationBroadcastSettingsTable",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(OfficeBranchSettings),
    "reactOfficeBranchSettings",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(NursingQuestionSettingsSection),
    "reactNursingQuestionSettingsSection",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(PlanOfCareTypeSettingsSection),
    "reactPlanOfCareTypeSettingsSection",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(UndoReassignMissedDutyButton),
    "reactUndoReassignMissedDutyButton",
    angular.module("dashboard"),
    {
      planOfCareDutyId: "<",
      visitInstanceId: "<",
      targetVisitInstanceId: "<",
      onUndone: "&",
    }
  );

  angularize(
    withAppOnly(PdfEditorSection),
    "reactPdfEditorSection",
    angular.module("dashboard"),
    {}
  );

  angularize(
    withAppOnly(withRouter(TasksNewPage)),
    "reactTasksNew",
    angular.module("dashboard"),
    {}
  );

  angularize(withAppOnly(withRouter(TasksV2Page)), "reactTasksV2", angular.module("dashboard"), {});

  angularize(
    withAppOnly(withRouter(RnSchedulingMapPage)),
    "reactRnSchedulingMap",
    angular.module("dashboard"),
    {}
  );
}
